<template>
  <div class="maintenanceProject">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            年度維養計畫新增／編輯
          </div>
          <div class="tip">
            可在此編輯、上傳設備資料
          </div>
        </div>
      </div>
      <el-tabs
        id="AssetTab"
        v-model="activeName"
        :before-leave="checkTab"
      >
        <el-tab-pane :name="maintenanceProjectDetailName">
          <span slot="label">計畫明細</span>
        </el-tab-pane>
        <el-tab-pane name="maintenanceProjectRecord">
          <span
            v-if="!isAdding"
            slot="label"
          >執行紀錄</span>
        </el-tab-pane>
      </el-tabs>
      <router-view ref="view" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    planId () {
      return this.$route.params.planId
    },
    maintenanceProjectDetailName () {
      return this.planId
        ? 'maintenanceProjectDetailWithPlanId'
        : 'maintenanceProjectDetail'
    },
    activeName () {
      return this.$route.name
    },
    isAdding () {
      return !this.planId
    }
  },
  methods: {
    checkTab (activeName, oldActiveName) {
      if (activeName !== oldActiveName) {
        this.$router.push({
          name: activeName,
          params: {
            planId: this.planId
          }
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.maintenanceProject {
  @include mainLayer();
}
</style>
